import { render, staticRenderFns } from "./PolicyAlertChart.vue?vue&type=template&id=54390c6c&"
import script from "./PolicyAlertChart.vue?vue&type=script&lang=js&"
export * from "./PolicyAlertChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports